import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcc45cba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__content-logo" }, "Seven Media CRM", -1))
const _hoisted_4 = { class: "header__content-action" }
const _hoisted_5 = { class: "action" }
const _hoisted_6 = {
  href: "#",
  class: "action__user"
}
const _hoisted_7 = { class: "action__menu" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "action__menu-box-title" }, "Notifications", -1))
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "notification" }
const _hoisted_11 = {
  key: 0,
  class: "notification__icon"
}
const _hoisted_12 = {
  key: 1,
  class: "notification__icon"
}
const _hoisted_13 = {
  key: 2,
  class: "notification__icon"
}
const _hoisted_14 = {
  key: 3,
  class: "notification__icon"
}
const _hoisted_15 = {
  key: 4,
  class: "notification__icon"
}
const _hoisted_16 = { class: "notification__content" }
const _hoisted_17 = { class: "notification__content-message" }
const _hoisted_18 = { class: "notification__content-created_at" }
const _hoisted_19 = {
  key: 0,
  class: "is-view-all"
}
const _hoisted_20 = {
  key: 0,
  class: "action__menu-box-message"
}
const _hoisted_21 = { class: "action__menu" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "action__menu-box-title" }, "Menu", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Coin = _resolveComponent("Coin")!
  const _component_Connection = _resolveComponent("Connection")!
  const _component_View = _resolveComponent("View")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_User = _resolveComponent("User")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", _hoisted_6, " Hi, " + _toDisplayString(_ctx.user.name), 1),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: "#",
                  class: "action__menu-icon",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isActionMenuBoxNotificationVisible = true), ["prevent"]))
                }, [
                  _createVNode(_component_Notification)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["action__menu-box", { 'action__menu-box--is-visible': _ctx.isActionMenuBoxNotificationVisible }])
                }, [
                  _hoisted_8,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: notification.id
                      }, [
                        _createElementVNode("a", {
                          href: _ctx.getNotificationUrl(notification)
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            (_ctx.getNotificationType(notification) === 'Partner')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createVNode(_component_Coin)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.getNotificationType(notification) === 'Deal')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_Connection)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.getNotificationType(notification) === 'Site')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_View)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.getNotificationType(notification) === 'Offboarding')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_MessageBox)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.getNotificationType(notification) === 'Onboarding')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_MessageBox)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, _toDisplayString(notification.message), 1),
                              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.getDateTimeFormat(notification.created_at)), 1)
                            ])
                          ])
                        ], 8, _hoisted_9)
                      ]))
                    }), 128)),
                    (_ctx.isNotificationsSet)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                          (_ctx.isUserRoleAbilityAdministrator)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: 'AdministrationAdministratorNotificationsIndex' }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("View all")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isUserRoleAbilityOwner)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: { name: 'AdministrationOwnerNotificationsIndex' }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("View all")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isUserRoleAbilitySuperAdministrator)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 2,
                                to: { name: 'AdministrationSuperAdministratorNotificationsIndex' }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("View all")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isNotificationsSet === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Currently, there are no notifications..."))
                    : _createCommentVNode("", true)
                ], 2)
              ])), [
                [_directive_click_outside, _ctx.setIsActionMenuBoxNotificationVisible]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("a", {
                  href: "#",
                  class: "action__menu-icon",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isActionMenuBoxUserVisible = true), ["prevent"]))
                }, [
                  _createVNode(_component_User)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["action__menu-box", { 'action__menu-box--is-visible': _ctx.isActionMenuBoxUserVisible }])
                }, [
                  _hoisted_22,
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                      }, "Settings")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setLogout && _ctx.setLogout(...args)), ["prevent"]))
                      }, "Logout")
                    ])
                  ])
                ], 2)
              ])), [
                [_directive_click_outside, _ctx.setIsActionMenuBoxUserVisible]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}